import { Box, Checkbox, DialogContent, Modal, ModalDialog, Stack } from '@mui/joy';
import { useState } from 'react';

import { Notice } from '@MP/shared/api/types';
import { RectangleButton } from '@MP/shared/components/Button';

interface NoticeDialogProps {
  notice: Notice;
  onClose: (optionChecked: boolean) => void;
}

const NoticeDialog = ({ notice, onClose }: NoticeDialogProps) => {
  const [open, setOpen] = useState(true);
  const [optionChecked, setOptionChecked] = useState(false);

  const optionLabel = notice.enableCheckboxToDisableToday ? '오늘 하루 보지 않기' : '더 이상 보지 않기';

  const handleLink = (url: string) => {
    window.open(url, '_blank');
  };

  const handleClose = () => {
    setOpen(false);
    onClose(optionChecked);
  };

  return (
    <Modal open={open}>
      <ModalDialog>
        <DialogContent>
          <Box position={'relative'}>
            <img src={notice.image} alt="" />
            {notice.link.map((l, idx) => {
              return (
                <Box
                  key={idx}
                  position={'absolute'}
                  left={l.x}
                  top={l.y}
                  width={l.width}
                  height={l.height}
                  sx={{ cursor: 'pointer' }}
                  onClick={() => handleLink(l.url)}
                />
              );
            })}
          </Box>
          <Stack px={2} py={1} direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
            <Checkbox
              label={optionLabel}
              checked={optionChecked}
              onChange={(e) => {
                setOptionChecked(e.target.checked);
              }}
            />
            <RectangleButton variant="solid" onClick={handleClose}>
              닫기
            </RectangleButton>
          </Stack>
        </DialogContent>
      </ModalDialog>
    </Modal>
  );
};

export { NoticeDialog };
